import React from 'react';
import { IOldIconProps } from './type';

const Delete: React.FC<IOldIconProps> = ({
  color = '#000',
  width,
  height,
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.085 10.298h4.821A2.569 2.569 0 0016.5 8.525a2.534 2.534 0 00-2.415 1.773zm6.4 0A4.062 4.062 0 0016.5 7a4.054 4.054 0 00-3.984 3.298H8.762a.761.761 0 00-.539 1.302.762.762 0 00.539.223h1.497L11.13 22.2A3.077 3.077 0 0014.162 25h4.679a3.07 3.07 0 003.047-2.8l.865-10.377h1.485a.762.762 0 000-1.525h-3.754zm-7.846 11.773l-.846-10.248h9.425l-.86 10.248a1.525 1.525 0 01-1.524 1.403h-4.672a1.541 1.541 0 01-1.523-1.403zm2.438-1.223h.052a.762.762 0 00.71-.812l-.305-4.396a.765.765 0 10-1.524.1l.305 4.397a.766.766 0 00.762.71zm3.367-.207a.761.761 0 01-.52.207l-.056-.003a.76.76 0 01-.71-.812l.305-4.396a.765.765 0 011.336-.453c.134.152.201.351.188.554l-.305 4.396a.763.763 0 01-.238.507z"
        fill={color}
      />
    </svg>
  );
};

export default Delete;
